


export function convertSectorName(sector: string, lang: string): string {
    if (lang === "tr")
        switch (sector) {
            case "Atik Yon ve Geri Donusum":
                return "Atık Yön ve Geri Dönüşüm";
            case "Bilisim":
                return "Bilişim";
            case "Danismanlik":
                return "Danışmanlık";
            case "Dayanikli Tuketim":
                return "Dayanıklı Tüketim";
            case "Denizcilik":
                return "Denizcilik";
            case "Diger":
                return "Diğer";
            case "Egitim":
                return "Eğitim";
            case "Elektrik":
                return "Elektrik";
            case "Enerji":
                return "Enerji";
            case "Finans":
                return "Finans";
            case "Gida":
                return "Gıda";
            case "Guvenlik":
                return "Güvenlik";
            case "Havacilik":
                return "Havacılık";
            case "Hizmet":
                return "Hizmet";
            case "Hizli Tuketim":
                return "Hızlı Tüketim";
            case "Kimya":
                return "Kimya";
            case "Maden":
                return "Maden";
            case "Medya":
                return "Medya";
            case "Otomotiv":
                return "Otomotiv";
            case "Perakende":
                return "Perakende";
            case "Saglik":
                return "Sağlık";
            case "Sigortacilik":
                return "Sigortacılık";
            case "Tarim":
                return "Tarım";
            case "Tekstil":
                return "Tekstil";
            case "Telekom":
                return "Telekom";
            case "Ticaret":
                return "Ticaret";
            case "Turizm":
                return "Turizm";
            case "Uretim":
                return "Üretim";
            default:
                return sector;
        }
    else
        switch (sector) {
            case "Atik Yon ve Geri Donusum":
                return "Waste Management and Recycling";
            case "Bilisim":
                return "Information Technology";
            case "Danismanlik":
                return "Consulting";
            case "Dayanikli Tuketim":
                return "Durable Consumer Goods";
            case "Denizcilik":
                return "Maritime";
            case "Diger":
                return "Other";
            case "Egitim":
                return "Education";
            case "Elektrik":
                return "Electricity";
            case "Enerji":
                return "Energy";
            case "Finans":
                return "Finance";
            case "Gida":
                return "Food";
            case "Guvenlik":
                return "Security";
            case "Havacilik":
                return "Aviation";
            case "Hizmet":
                return "Service";
            case "Hizli Tuketim":
                return "Fast-Moving Consumer Goods";
            case "Kimya":
                return "Chemistry";
            case "Maden":
                return "Mining";
            case "Medya":
                return "Media";
            case "Otomotiv":
                return "Automotive";
            case "Perakende":
                return "Retail";
            case "Saglik":
                return "Healthcare";
            case "Sigortacilik":
                return "Insurance";
            case "Tarim":
                return "Agriculture";
            case "Tekstil":
                return "Textile";
            case "Telekom":
                return "Telecommunications";
            case "Ticaret":
                return "Trade";
            case "Turizm":
                return "Tourism";
            case "Uretim":
                return "Manufacturing";
            default:
                return sector;
        }

}
